import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import PDFViewer from '../../PDFViewer';
import _ from 'lodash';
import styled from 'styled-components';

import { downloadPDF, fileDownload, notify } from '../../../utils';
import ActionIcon from '../../custom/ActionIcon';
import apiClient from '../../../apiClient';

const deleteAccess = new Set([
    'mozart@choice.aero',
    'vvieira@choice.aero',
    'bwaldman@choice.aero',
    'byron@choice.aero',
    'frank@choice.aero',
    'nokoji@choice.aero' // added per mozart 2025-01-21
]);

export default ({
    user,
    modal,
    setModal,
    selectedFile,
    setFiles,
    personal
}) => {

    const toggle = () => setModal(!modal);

    const printFile = () => {
        const printDoc = `
            <!DOCTYPE html>
            <html>
                <head>
                    <link rel="stylesheet" type="text/css" media="print" href="print.css" />
                </head>
                <body>
                    <img src=${selectedFile.accessLink} />
                </body>
                <script>
                    setTimeout(() => {
                        window.print();
                    }, 1000);
                </script>
            </html>
        `;

        const myWindow = window.open("", "MsgWindow", "width=1920,height=1080");
        myWindow.document.write(printDoc);
    }

    const deleteFile = async () => {
        const { id, s_file_name, s_container } = selectedFile;
        await apiClient.post(`/deleteFile`, {
            id, s_file_name, s_container
        });
        setFiles(prev => {
            const files = prev.filter(file => file.id !== id);
            return files;
        })
        toggle();
        notify('File Deleted');
    }

    const parts = _.get(selectedFile, 's_file_name', '').split('.');
    const fileType = parts ? parts[parts.length - 1] : '';
    const isPDF = fileType === 'pdf';

    if (!selectedFile) return null;

    return (
        <Modal isOpen={modal} toggle={toggle} style={{ maxWidth: '1000px', width: '100%' }}>
            <ModalHeader>
                <span className={'float-left'}>View File: {selectedFile.s_file_type}</span>
                <Button className={'float-right'} onClick={() => printFile()}>Print</Button>
                {
                    isPDF && (
                        <Button className={'float-right'} onClick={() => downloadPDF(selectedFile.accessLink, selectedFile.s_file_name)}>Download</Button>
                    )
                }
            </ModalHeader>
            <ModalBody className={'text-center mx-auto'}>
                {
                    selectedFile.accessLink ?
                        <div style={{ width: '900px', height: 'auto' }}>
                            {
                                isPDF ?
                                    <PDFViewer link={selectedFile.accessLink} /> :
                                    <img src={selectedFile.accessLink} />
                            }
                        </div> :
                        <h4>No File Found</h4>
                }
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer update={true}>
                        {
                            !personal && deleteAccess.has(_.get(user, 's_email', '').toLowerCase()) && (
                                <ActionIcon type={'delete'} onClick={() => deleteFile()} />
                            )
                        }
                        <Button color="secondary" onClick={toggle}>Close</Button>
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;